<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="suppliertypes.icon" class="mr-1"></i>
            <span>{{ suppliertypes.title }}</span>
          </b-col>
        </b-row>

      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Description" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="name" :debounce="suppliertypes.debounce"
                      placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!name" @click="name = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3" class="pl-2">
                <b-form-group label="Agent Use? (icon)" label-for="hasicon" label-cols="12">
                  <treeselect instanceId="hasicon" type="number" v-model="hasicon" :clearable="true"
                    :options="hasicon_options"></treeselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="suppliertypes" :icon="suppliertypes.icon"
            :busy="suppliertypes.busy" :toolbarlibrary="suppliertypes.toolbarlibrary" :tools="suppliertypes.tools"
            :badges="suppliertypes.badges" :fields="suppliertypes.fields" :items="suppliertypes.items"
            :limit="suppliertypes.limit" :downloaded="suppliertypes.downloaded" :page="suppliertypes.page"
            @load="suppliertypes_load" @click="suppliertypes_click" @changed="suppliertypes_click('save', $event)"
            @select="suppliertypes_select">
          </d-table>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="suppliertypes.selected" :config="cconfig"
          @discard="suppliertypes_click('discard')" @go="suppliertypes_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-bars mr-2"></i>All Codes
          </b-button>
        </div>
      </b-card-footer>
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import Setup_SupplierTypeEdit from "./Components/Setup_SupplierTypeEdit";

export default {
  name: "SupplierTypes",
  components: { Setup_SupplierTypeEdit },
  watch: {
    async name() {
      await this.suppliertypes_load(0);
    },
    async hasicon() {
      await this.suppliertypes_load(0);
    },
  },
  data() {
    return {
      name: null,
      hasicon: "true",
      hasicon_options: [
        {
          id: "true",
          label: "Yes",
        },
        {
          id: "false",
          label: "No",
        },
      ],

      suppliertypes: {
        title: "Supplier Types",
        icon: "fa fa-bars",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,


        tools: "go,filter,download,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-35px",
          },

          {
            key: "id",
            label: "Code",
            sortable: true,
          },
          {
            key: "faicon",
            label: "Icon",
            class: "text-center w-35px",
            formatter: (value, key, item) => {
              if (value) {
                return "<i class='fa " + value + "'></i>"
              }
            }
          },
          {
            key: "name",
            label: "Description",
            sortable: true,
          },
          // {
          //   key: "reports",
          //   label: "Reports",
          //   sortable: true,
          // },
          // {
          //   key: "order",
          //   label: "Order",
          //   sortable: true,
          //   class: "text-left",
          // },
          // {
          //   key: "ownevent",
          //   label: "Own Event",
          //   sortable: true,
          // },
          {
            key: "amexcode",
            label: "AMEX Code",
            sortable: true,
          },
          {
            key: "salesnl",
            label: "Sales N/L",
            sortable: true,
          },
          {
            key: "costsnl",
            label: "Costs N/L",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "vatable",
            type: "badge",
            Yes: "success",
            No: "danger",
            formatter: (value, key, item) => {
              if (value == false) {
                return "No";
              } else if (value == true) {
                return "Yes";
              } else {
                return "";
              }
            },
          },
          {
            key: "invoicetype",
            type: "badge",
            P: "info",
            N: "danger",
            E: "info",
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
     this.accessdenied();
    await this.suppliertypes_load();
  },
  methods: {
     accessdenied() {
      this.suppliertypes.denied = [];
      if (!this.user.permissions.includes("setup_suppliertypes.admin")) {
        this.suppliertypes.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_suppliertypes.admin")) {
        this.suppliertypes.denied.push("add");
        this.suppliertypes.denied.push("save");
      }

    },
    async suppliertypes_load(offset, limit, page) {
      console.log('suppliertypes_load', offset, limit, page)
      let state = this.suppliertypes;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        name: this.name,
        hasicon: this.hasicon,
        dateformat: "DD/MM/YYYY"
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query suppliertypes(
                $limit: Int
                $offset: Int
                $name: String   
                  $hasicon: String           
                $dateformat: String                
              ) {
                suppliertypes(
                  limit: $limit
                  offset: $offset
                  name: $name 
                    hasicon: $hasicon 
                  dateformat: $dateformat
              
                ) {
                  id
                name
                faicon
                reports
                order
                ownevent
                showeventdetail
                amexcode
                heads
                column
                salesnl
                costsnl
                matchsuppliervat
                matchsuppliernvat
                hasicon
                rows
                updated_at
                updated_by
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE  

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.suppliertypes
        } else {
          state.items = response.data.suppliertypes;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async suppliertypes_click(a, ss) {

      let state = this.suppliertypes;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.suppliertypes_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          break;
        case "go":
          this.component = null;
          this.suppliertypes_load();
          break;
        case "add":
        case "edit":
          this.component = "Setup_SupplierTypeEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async suppliertypes_select(ss, tools) {

      let state = this.suppliertypes;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation suppliertypes_save(
                $rows: [Suppliertype_input]             
              ) {
                suppliertypes_save(rows: $rows) {
                  id
                name
                reports
                order
                ownevent
                showeventdetail
                amexcode
                heads
                column
                salesnl
                costsnl
                matchsuppliervat
                matchsuppliernvat
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation suppliertypes_delete(
                $rows: [Suppliertype_input]
              ) {
                suppliertypes_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.suppliertypes_load(0);
    },
  },
};
</script>

<style></style>